import React, { PropTypes } from 'react';
import Translate from 'react-translate-component';
import Modal from 'react-modal';
import { connect } from 'react-redux';
import { Spinner } from 'components';

import {
  cancel
} from 'redux/modules/bank-id/index';

class BankId extends React.Component {

  static propTypes = {
    // Redux state
    socialSecurityNr: PropTypes.string,
    inProgress: PropTypes.bool,
    entity: PropTypes.object,

    // Thunks
    cancel: PropTypes.func
  };

  renderOpenComputerAppButton () {
    if (this.props.entity && this.props.entity.autostart !== null) {
      return (<a className="btn" href={this.props.entity.autostart}>
        <Translate content='OPEN_BANK_ID_COMPUTER_APP'/>
      </a>);
    }
  }

  render () {
    return (
      <Modal
        className='modal'
        contentLabel=''
        isOpen={this.props.inProgress}
        onRequestClose={this.props.cancel}>
        <div className='modal-content bank-id-modal'>
          <button className='close' onClick={this.props.cancel}></button>
          <p><Translate content='OPEN_BANK_ID_APP'/></p>
          <Spinner/>
          <div className="btn-wrapper">
            <button className="btn outlined white" onClick={this.props.cancel}><Translate content='CANCEL'/></button>
            &nbsp;
            {this.renderOpenComputerAppButton()}
          </div>
        </div>
      </Modal>
    );
  }
}

function mapStateToProps (state) {
  return {
    socialSecurityNr: state.bankId.socialSecurityNr,
    inProgress: state.bankId.inProgress,
    entity: state.bankId.entity
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    cancel: () => dispatch(cancel())
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(BankId);



/** WEBPACK FOOTER **
 ** ./src/components/bank-id/bank-id.js
 **/